// GST state code (first 2 digits of any GSTIN) → state abbreviation/name.
// Derived purely from the GSTIN string itself — no backend lookup or
// gst_credentials dependency needed, so this works for ANY GSTIN (a
// company's own registered GSTIN or a supplier's).
export const GST_STATE: Record<string, { abbr: string; name: string }> = {
  "01": { abbr: "JK", name: "Jammu & Kashmir" },
  "02": { abbr: "HP", name: "Himachal Pradesh" },
  "03": { abbr: "PB", name: "Punjab" },
  "04": { abbr: "CH", name: "Chandigarh" },
  "05": { abbr: "UK", name: "Uttarakhand" },
  "06": { abbr: "HR", name: "Haryana" },
  "07": { abbr: "DL", name: "Delhi" },
  "08": { abbr: "RJ", name: "Rajasthan" },
  "09": { abbr: "UP", name: "Uttar Pradesh" },
  "10": { abbr: "BI", name: "Bihar" },
  "11": { abbr: "SK", name: "Sikkim" },
  "12": { abbr: "AR", name: "Arunachal Pradesh" },
  "13": { abbr: "NL", name: "Nagaland" },
  "14": { abbr: "MN", name: "Manipur" },
  "15": { abbr: "MZ", name: "Mizoram" },
  "16": { abbr: "TR", name: "Tripura" },
  "17": { abbr: "ME", name: "Meghalaya" },
  "18": { abbr: "AS", name: "Assam" },
  "19": { abbr: "WB", name: "West Bengal" },
  "20": { abbr: "JH", name: "Jharkhand" },
  "21": { abbr: "OR", name: "Odisha" },
  "22": { abbr: "CG", name: "Chhattisgarh" },
  "23": { abbr: "MP", name: "Madhya Pradesh" },
  "24": { abbr: "GJ", name: "Gujarat" },
  "25": { abbr: "DD", name: "Daman & Diu" },
  "26": { abbr: "DN", name: "Dadra & Nagar Haveli" },
  "27": { abbr: "MH", name: "Maharashtra" },
  "28": { abbr: "AP", name: "Andhra Pradesh" },
  "29": { abbr: "KA", name: "Karnataka" },
  "30": { abbr: "GA", name: "Goa" },
  "31": { abbr: "LD", name: "Lakshadweep" },
  "32": { abbr: "KL", name: "Kerala" },
  "33": { abbr: "TN", name: "Tamil Nadu" },
  "34": { abbr: "PY", name: "Puducherry" },
  "35": { abbr: "AN", name: "Andaman & Nicobar" },
  "36": { abbr: "TG", name: "Telangana" },
  "37": { abbr: "AP", name: "Andhra Pradesh" },
};

export function getStateInfo(gstin: string): { abbr: string; name: string } {
  const code = gstin.slice(0, 2);
  return GST_STATE[code] ?? { abbr: gstin.slice(0, 2).toUpperCase(), name: "Unknown" };
}